import _asyncToGenerator from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
var __jsx = React.createElement;
import _regeneratorRuntime from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import React from 'react';
import { get } from 'lodash';
import { Layout } from "../components/_global";
import FavouriteList from "../components/Favourites";
import Banner from "../components/Plugin/Banner";
import { WithLowProtection } from "../containers/withProtection";
import { useIsMobileTablet } from "../utils/customHooks";
var FavouritesWithProtection = WithLowProtection(FavouriteList);
var DEFAULT_TITLE = 'My Favourites';
var DEFAULT_DESCRIPTION = 'Earn Qantas Points shopping online at over 450 top brands including Myer, ebay, Adore Beauty, THE ICONIC, David Jones, Apple and more.';
var Favourites = function Favourites(_ref) {
  var _ref$page = _ref.page,
    page = _ref$page === void 0 ? {} : _ref$page;
  var _useIsMobileTablet = useIsMobileTablet(),
    _useIsMobileTablet2 = _slicedToArray(_useIsMobileTablet, 1),
    isMobileTablet = _useIsMobileTablet2[0];
  var metaTitle = get(page, 'meta.title', DEFAULT_TITLE);
  var metaDescription = get(page, 'meta.description', DEFAULT_DESCRIPTION);
  return __jsx(Layout, {
    title: metaTitle,
    description: metaDescription,
    slug: "favourites"
  }, __jsx(FavouritesWithProtection, null), !isMobileTablet && __jsx(Banner, null));
};
Favourites.getInitialProps = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
    var page;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            page = _ref2.query.page;
            return _context.abrupt("return", {
              page: page
            });
          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref3.apply(this, arguments);
  };
}();
export default Favourites;